import api from './api';

const jobAPI = {
  getAvailableJobs: (params = {}) => api.get('/jobs/available', { params }),
  getMyJobs: (params = {}) => api.get('/jobs/my-jobs', { params }),
  getJobById: (id) => api.get(`/jobs/${id}`),
  acceptJob: (jobId, data = {}) => api.post(`/jobs/${jobId}/accept`, data),
  declineJob: (jobId, data = {}) => api.post(`/jobs/${jobId}/decline`, data),
  unassignJob: (jobId, data = {}) => api.post(`/jobs/${jobId}/unassign`, data),
  assignTeamMember: (jobId, team_member_id, certification_number = null) =>
    api.put(`/jobs/${jobId}/assign-team-member`, { team_member_id, certification_number }),
  confirmAvailability: (jobId, data = {}) => api.post(`/jobs/${jobId}/confirm-availability`, data),
  // New availability indication methods
  indicateAvailability: (jobId, mileage_requested = 0, mileage_rate = null) =>
    api.post(`/jobs/${jobId}/indicate-available`, { mileage_requested, mileage_rate: mileage_requested > 0 ? mileage_rate : undefined }),
  indicateNotAvailable: (jobId, reason = '') => api.post(`/jobs/${jobId}/indicate-not-available`, { reason }),
  startJob: (jobId, locationData = {}) => api.post(`/interpreters/jobs/${jobId}/start`, locationData),
  endJob: (jobId, data = {}) => api.post(`/interpreters/jobs/${jobId}/end`, {
    client_timezone_offset_minutes: new Date().getTimezoneOffset(),
    ...data
  }),
  submitCompletionReport: (jobId, reportData) => api.post(`/jobs/${jobId}/completion-report`, reportData),
  getEarnings: (params = {}) => api.get('/interpreters/earnings', { params }),
};

export default jobAPI;
